import React, { useState, useEffect, useCallback } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AccordionContainer from "../../components/accordian/component";
import AppButton from "../../components/button/component";
import RealtionShipAdvice from "../../assets/sell/relationship-advice-pic.svg";
import GrowthOpportunities from "../../assets/sell/growth-opportunities-pic.svg";
import CommunitySupport from "../../assets/sell/community-support-pic.svg";
import PersonalizedInsights from "../../assets/sell/personalized-insights-pic.svg";
import CareerGuidence from "../../assets/sell/career-guidence-pic.svg";
import Arrow from "../..//assets/sell/sell-button-arrow.svg";
import FeatureCard from "../../components/feature-card/component";
import GrowthTips from "../../assets/sell/sell-growth-tips.svg";
import IdealJob from "../../assets/sell/sell-ideal-job-image.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FunnelStepTypes from "../funnel-step/types";
import LOGO from "../../assets/logo/insightfulTraitsLogo.png";
import MoneyBackBanner from "../../components/money-back-banner";
import { useDispatch } from "react-redux";
import Loader from "../../components/loader";
import { trackEvents } from "../../utils/tracking-events";
import { getPortalCD, readCookie } from "../../utils/helpers";
import {
  convertToLowerCase,
  getCookie,
  getCountryCode,
} from "../../utils/utility-functions";
import {
  noTestImage,
  PERSONALITY_TEST_ASSESSMENT_ID,
  BIG_FIVE_TEST_ASSESSMENT_ID,
  MODEL_TYPE_ENNEAGRAM,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  ADHD_TEST_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  CHECKOUT_AB_TEST_ID,
  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
  COUNTRY_CODE,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
  DEPRESSION_TEST_ASSESSMENT_ID,
  BIPOLAR_DISORDER_ASSESSMENT_ID,
} from "../../utils/general-config";
import { useTranslation } from "react-i18next";
import PlanAssessmentResults from "../../components/plan-assessment-results";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";
import useSignOut from "../../utils/sign-out";

const PushAssessmentAttemptIdToFunnelStep = (assessmentAttemptId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ATTEMPT_ID,
  assessmentAttemptId,
});

const PushAssessmentIdToFunnelStep = (assessmentId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ID,
  assessmentId,
});

const Plan = ({
  getAssessmentResultByAssessmentAttemptIdConnect,
  getPlansConnect,
  funnelStep,
  getAssessmentAttemptByUserIdConnect,
  GetUserByIdConnect,
  IsGuestOrPremiumUserConnect,
  getAbTestConnect,
  getInsightfulContentConnect,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const signOut = useSignOut();
  // const token = getCookie("jwtToken");
  const [isEnneagramContentLoading, setIsEnneagramContentLoading] =
    useState(false);
  const {
    selectedPlan,
    userGUID,
    email,
    gender,
    assessmentAttemptId: attemptId,
    countryCD: reduxCountryCD,
    currencyCD,
    assessmentId,
    isAuth,
  } = funnelStep || {};
  const countryCD = getCountryCode(reduxCountryCD);
  const country = countryCD;
  const isVisibleInUSUKCanada =
    country === COUNTRY_CODE.USA ||
    country === COUNTRY_CODE.CANADA ||
    country === COUNTRY_CODE.UK;

  const queryParams = new URLSearchParams(location.search);
  // Extracting the language code from the URL path
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  let assessmentAttemptId = queryParams.get("assessmentAttemptId");
  const [userAssessmentResult, setUserAssessmentResult] = useState(null);
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD, currentLocale);
  const checkoutPath = PathHelper(APP_NAVIGATION.CHECKOUT, currentLocale);
  const checkoutCPath = PathHelper(APP_NAVIGATION.CHECKOUT_C, currentLocale);

  const [planData, setPlanData] = useState([]);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isTestTaken, SetIsTestTaken] = useState(true);
  const [enneagramKeyTraits, setEnneagramKeyTraits] = useState([]);

  const { t } = useTranslation();

  const PushSelectedPlanToFunnelStep = (selectedPlan) => ({
    type: FunnelStepTypes.SET_SELECTED_PLAN,
    selectedPlan,
  });

  useEffect(() => {
    if (!isAuth) {
      navigate(loginPath.next);
    }
  }, [isAuth]);

  useEffect(() => {
    if (userGUID) {
      IsGuestOrPremiumUserConnect(userGUID).then((res) => {
        if (res && res?.isPremiumOrGuestUser) {
          navigate(dashboardPath.next);
        }
      });
    }
  }, [userGUID]);

  useEffect(() => {
    setIsLoading(true);
    trackEvents("planView", {
      userGuid: userGUID,
      email: email,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      countryCD,
      currencyCD,
      portalCD: getPortalCD(currentLocale),
      gender: gender,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
  }, []);

  const validAssessmentIds = new Set([
    PERSONALITY_TEST_ASSESSMENT_ID,
    BIG_FIVE_TEST_ASSESSMENT_ID,
    ENNEAGRAM_TEST_ASSESSMENT_ID,
    LIKEABILITY_TEST_ASSESSMENT_ID,
    DISC_TEST_ASSESSMENT_ID,
    PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
    CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
    ADHD_TEST_ASSESSMENT_ID,
    EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
    DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
    AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
    HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
    DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
    LOVE_STYLE_TEST_ASSESSMENT_ID,
    NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
    ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
    ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
    DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
    CAREER_TEST_ASSESSMENT_ID,
    FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
    ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
    COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
    DEPRESSION_TEST_ASSESSMENT_ID,
    BIPOLAR_DISORDER_ASSESSMENT_ID,
  ]);

  useEffect(() => {
    if (userGUID) {
      GetUserByIdConnect(userGUID).then((res) => {
        if (res) {
          if (res.isValidEmail == false) {
            signOut({ isNavigate: true });
            return;
          }
        }
      });
    }
  }, [userGUID]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        if (!assessmentAttemptId) {
          const result = await getAssessmentAttemptByUserIdConnect(
            userGUID,
            currentLocale,
          );

          if (result?.length > 0) {
            const completedAssessmentResult = result.filter(
              (item) =>
                validAssessmentIds.has(item.assessmentId) &&
                item.personality !== null,
            );
            const latestAttempt = completedAssessmentResult.sort(
              (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
            )[0];

            // const latestAssessmentAttemptId = result
            //   ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
            //   ?.map((item, index) =>
            //     index === 0 ? item.assessmentAttemptId : null
            //   )
            //   ?.filter(Boolean)[0];

            assessmentAttemptId = latestAttempt?.assessmentAttemptId;

            // assessmentAttemptId = latestAssessmentAttemptId;

            const currentUrl = new URL(window.location.href);
            if (window.location.href.includes("assessmentAttemptId=")) {
              currentUrl.searchParams.delete("assessmentAttemptId");
              currentUrl.searchParams.set(
                "assessmentAttemptId",
                assessmentAttemptId,
              );
              window.history.pushState({}, "", currentUrl);
            }

            dispatch(
              PushAssessmentAttemptIdToFunnelStep(
                latestAttempt?.assessmentAttemptId,
              ),
            );
            dispatch(PushAssessmentIdToFunnelStep(latestAttempt?.assessmentId));
          } else {
            SetIsTestTaken(false);
          }
        }

        if (assessmentAttemptId) {
          const result = await getAssessmentResultByAssessmentAttemptIdConnect(
            assessmentAttemptId,
            currentLocale,
          );

          setUserAssessmentResult(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false); // Ensure loading is stopped
      }
    };

    fetchData();
  }, [assessmentAttemptId, getAssessmentResultByAssessmentAttemptIdConnect]);

  const traits = userAssessmentResult?.userTraits;

  const personalityGroup = userAssessmentResult
    ? userAssessmentResult?.personality?.role
    : "";

  const personalityType = userAssessmentResult
    ? userAssessmentResult?.personality?.title
    : "";

  const personalityName = userAssessmentResult
    ? userAssessmentResult?.personality?.name
    : "";

  const personalityNameEnglishCode = userAssessmentResult
    ? userAssessmentResult?.personality?.nameEnglishCode
    : "";

  const ENNEAGRAM_TEST =
    !!userAssessmentResult &&
    userAssessmentResult?.assessmentId === ENNEAGRAM_TEST_ASSESSMENT_ID;

  const isCareerPreferenceTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(CAREER_PREFERENCE_TEST_ASSESSMENT_ID);

  const isRomanticCompatibilityTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const isColorBlindTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(COLOR_BLINDNESS_TEST_ASSESSMENT_ID);

  const isCareerPreferenceOrRomanticCompatibilityTest =
    isCareerPreferenceTest || isRomanticCompatibilityTest;

  const isDepressionTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(DEPRESSION_TEST_ASSESSMENT_ID);

  const isBipolarTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(BIPOLAR_DISORDER_ASSESSMENT_ID);

  const fetchEnneagramContent = async () => {
    try {
      setIsEnneagramContentLoading(true); // Start loading
      const result = await getInsightfulContentConnect({
        modelType:
          MODEL_TYPE_ENNEAGRAM[currentLocale] ||
          MODEL_TYPE_ENNEAGRAM[LOCALE.EN],
        contentKey: userAssessmentResult?.personality?.title.toLowerCase(),
      });
      setEnneagramKeyTraits(result.content?.keyTraits?.Content);
      return result;
    } catch (error) {
      console.error("Error fetching enneagram content:", error);
    } finally {
      setIsEnneagramContentLoading(false);
    }
  };

  useEffect(() => {
    if (
      ENNEAGRAM_TEST &&
      userAssessmentResult?.personality?.title.toLowerCase()
    ) {
      fetchEnneagramContent();
    }
  }, [ENNEAGRAM_TEST, userAssessmentResult?.personality?.title]);

  useEffect(() => {
    getPlansConnect({
      // planType: parseInt(res?.caseValue) === 1 ? plan1995 : "_default",
      planType: "_default",
      currencyCD,
      countryCD,
      device: "null",
      locale:
        currentLocale === LOCALE.EN || currentLocale === LOCALE.ES
          ? currentLocale
          : LOCALE.EN,
    }).then((result) => {
      setPlanData(result);
      // Set default selected plan to the second plan (index 1)
      if (result && result.length > 1 && !selectedPlan) {
        dispatch(PushSelectedPlanToFunnelStep(result[1]));
      }
      setIsLoading(false);
      // const timeoutId = setTimeout(() => {
      //   setIsLoading(false);
      // }, 800);
    });
  }, [getPlansConnect, dispatch]);

  const accordianData =
    planData &&
    planData?.map((plan) => {
      const {
        id,
        description,
        label,
        unitPrice,
        scheduleTypeCD,
        recurringPrice,
        currencySymbol,
        maxSubUserCount,
      } = plan;

      return {
        id: id,
        title: label,
        unitPrice: unitPrice,
        recurringPrice: recurringPrice,
        currencySymbol: currencySymbol,
        scheduleTypeCD: scheduleTypeCD,
        maxSubUserCount: maxSubUserCount,
        // price: `${currencySymbol}${unitPrice} /${scheduleTypeCD}`,
        price: `${currencySymbol}${unitPrice}`,
        content: [
          ...(scheduleTypeCD === "YEAR"
            ? [
                {
                  title: `${t("plan.plan_feature_seven")}`,
                  image: PersonalizedInsights,
                  description: `${t("plan.plan_feature_seven")}`,
                },
              ]
            : []),

          ...(isCareerPreferenceTest || isDepressionTest || isBipolarTest
            ? [
                {
                  title: `${t("plan.plan_feature_one")}`,
                  image: PersonalizedInsights,
                  description: `${t("plan.plan_feature_one")}`,
                },
              ]
            : isRomanticCompatibilityTest
              ? [
                  {
                    title: `${t("plan.plan_feature_comprehensive_report")}`,
                    image: PersonalizedInsights,
                    description: `${t("plan.plan_feature_comprehensive_report")}`,
                  },
                ]
              : isColorBlindTest
                ? [
                    {
                      title: `${t("plan.plan_feature_one")}`,
                      image: PersonalizedInsights,
                      description: `${t("plan.plan_feature_one")}`,
                    },
                  ]
                : [
                    {
                      title: `${t("plan.plan_feature_complete_report")}`,
                      image: PersonalizedInsights,
                      description: `${t("plan.plan_feature_complete_report")}`,
                    },
                  ]),

          ...(isRomanticCompatibilityTest
            ? [
                {
                  title: `${t("plan.plan_feature_relationship_insights")}`,
                  image: GrowthOpportunities,
                  description: `${t(
                    "plan.plan_feature_relationship_insights",
                  )}`,
                },
              ]
            : []),

          ...(isColorBlindTest
            ? [
                {
                  title: `${t("plan.colorblind_plan_feature")}`,
                  image: GrowthOpportunities,
                  description: `${t("plan.colorblind_plan_feature")}`,
                },
              ]
            : []),

          ...(isCareerPreferenceTest
            ? [
                {
                  title: `${t("plan.plan_feature_career_insights")}`,
                  image: CareerGuidence,
                  description: `${t("plan.plan_feature_career_insights")}`,
                },
              ]
            : []),

          ...(isDepressionTest
            ? [
                {
                  title: `${t("plan.discover_depression_level")}`,
                  image: CareerGuidence,
                  description: `${t("plan.discover_depression_level")}`,
                },
              ]
            : []),

          ...(isBipolarTest
            ? [
                {
                  title: `${t("plan.discover_bipolar_likelihood")}`,
                  image: CareerGuidence,
                  description: `${t("plan.discover_bipolar_likelihood")}`,
                },
              ]
            : []),

          {
            title: `${t("plan.plan_feature_six")}`,
            image: CommunitySupport,
            description: `${t("plan.plan_feature_six")}`,
          },

          {
            title: `${t("plan.invite")} ${maxSubUserCount} ${t(
              "plan.plan_feature_two",
            )}`,
            image: CareerGuidence,
            description: `${t("plan.invite")} ${maxSubUserCount} ${t(
              "plan.plan_feature_two",
            )}`,
          },
          {
            title: `${t("plan.plan_feature_three")}`,
            image: RealtionShipAdvice,
            description: `${t("plan.plan_feature_three")}`,
          },
          ...(!isCareerPreferenceOrRomanticCompatibilityTest &&
          !isColorBlindTest &&
          !isDepressionTest &&
          !isBipolarTest
            ? [
                {
                  title: `${t("plan.plan_feature_five")}`,
                  image: GrowthOpportunities,
                  description: `${t("plan.plan_feature_five")}`,
                },
                {
                  title: `${t("plan.plan_feature_share_results")}`,
                  image: CareerGuidence,
                  description: `${t("plan.plan_feature_share_results")}`,
                },
              ]
            : [
                {
                  title: `${t("plan.plan_feature_four")}`,
                  image: CareerGuidence,
                  description: `${t("plan.plan_feature_four")}`,
                },
              ]),
        ],
        policy: description,
      };
    });

  const onAccordionClick = useCallback(
    (selectedPlan) => {
      dispatch(PushSelectedPlanToFunnelStep(selectedPlan));
    },
    [dispatch],
  );
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  const handleContinue = () => {
    // if (!isVisibleInUSUKCanada) {
    //   navigate(
    //     `${checkoutPath.next}?pt=${personalityType}&sku=${
    //       selectedPlan?.id
    //     }&pn=${personalityName}&pnes=${personalityNameEnglishCode}&pg=${personalityGroup}&assessmentAttemptId=${
    //       assessmentAttemptId || attemptId
    //     }`
    //   );
    //   return;
    // }

    // getAbTestConnect({
    //   abTestId: CHECKOUT_AB_TEST_ID,
    //   userGuid: userGUID,
    //   portalCD: "IT",
    //   visitorId: readCookie("visitorGuid"),
    // }).then((res) => {
    //   if (res && res?.caseValue) {
    //     if (parseInt(res?.caseValue) === 1) {
    //       navigate(
    //         `${checkoutPath.next}?pt=${personalityType}&sku=${
    //           selectedPlan?.id
    //         }&pn=${personalityName}&pnes=${personalityNameEnglishCode}&pg=${personalityGroup}&assessmentAttemptId=${
    //           assessmentAttemptId || attemptId
    //         }`
    //       );
    //     } else {
    //       navigate(
    //         `${checkoutCPath.next}?pt=${personalityType}&sku=${
    //           selectedPlan?.id
    //         }&pn=${personalityName}&pnes=${personalityNameEnglishCode}&pg=${personalityGroup}&assessmentAttemptId=${
    //           assessmentAttemptId || attemptId
    //         }`
    //       );
    //     }
    //   }
    // });
    navigate(
      `${checkoutCPath.next}?pt=${personalityType}&sku=${
        selectedPlan?.id
      }&pn=${personalityName}&pnes=${personalityNameEnglishCode}&pg=${personalityGroup}&assessmentAttemptId=${
        assessmentAttemptId || attemptId
      }`,
    );
  };

  return (
    <div className="">
      <div className="hidden md:block">
        <Header />
      </div>
      <Loader isLoading={isLoading || isEnneagramContentLoading} />
      <MoneyBackBanner />

      <div className="w-full flex justify-center items-center mt-16 md:mt-4 lg:mt-4">
        <div className="flex-shrink-0 mx-auto sm:mx-0 flex justify-center w-full sm:w-auto">
          <img
            src={LOGO}
            alt="logo"
            width={280}
            height={64}
            className="w-[185px] md:hidden h-auto flex flex-shrink-0"
          />
        </div>
      </div>

      {/* -----------------------------------First Section--------------------------- */}
      <div className=" bg-white  flex flex-col items-center  w-full">
        <div className="w-full max-w-[1200px] flex md:flex-col lg:flex-row justify-center gap-x-1 lg:gap-x-10">
          <h1 className="w-full flex flex-wrap sm:flex-nowrap justify-center lg:justify-start items-center m-0 font-bold text-center md:px-[20px] lg:px-[28px] pb-[0px] lg:pb-[10px] pt-[10px] md:pt-[0px] lg:pt-[20px] text-[clamp(1.25rem,2vw,2.25rem)]">
            <span className="text-[#444C5E] sm:whitespace-nowrap mr-2">
              {t("plan.select_plan")}
            </span>
            <span className="text-[#805AED] sm:whitespace-nowrap">
              {t("plan.full_report")}
            </span>
          </h1>

          <div className="lg:flex justify-center items-center hidden">
            <AppButton
              icon={Arrow}
              className="h-[64px] w-[400px] lg:w-full text-[16px] lg:text-[20px] font-semibold text-white bg-insightful-orange hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 gap-3 flex justify-center items-center"
              onClick={() => {
                if (selectedPlan) {
                  handleContinue();
                } else {
                  console.error("No plan selected");
                }
              }}
            >
              {t("plan.continue_cta")}
            </AppButton>
          </div>
        </div>

        <div className="w-full lg:px-20 pb-[5px] lg:pb-[10px] max-w-[1440px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 justify-center">
            {/* -----------------------------------Result Section--------------------------- */}
            <div className="flex flex-col items-center px-[20px] lg:order-1 order-2 max-w-full min-h-max mt-0 lg:mt-10">
              {userAssessmentResult?.assessmentId ===
                ROMANTIC_COMPATIBILITY_ASSESSMENT_ID && (
                <div className="flex flex-row gap-4 mt-[10px] lg:max-w-lg">
                  <div className="text-center gap-3 flex flex-col justify-center items-center max-w-full">
                    <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white">
                      {/* Personalized Results Text */}
                      <p
                        className="mt-10"
                        dangerouslySetInnerHTML={{
                          __html: t(
                            "plan.romantic_compatibility_text.long_text",
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {userAssessmentResult?.assessmentId ===
                COLOR_BLINDNESS_TEST_ASSESSMENT_ID && (
                <div className="flex flex-row gap-4 mt-[10px] lg:max-w-lg">
                  <div className="text-center gap-3 flex flex-col justify-center items-center max-w-full">
                    <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white">
                      {/* Colorblind Results Text */}
                      <p
                        className="mt-10"
                        dangerouslySetInnerHTML={{
                          __html: t("plan.colorblind_text.long_text"),
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
              <PlanAssessmentResults
                enneagramKeyTraits={enneagramKeyTraits}
                personalityName={personalityName}
                personalityType={personalityType}
                handleContinue={handleContinue}
                userTraits={traits}
                assessmentId={userAssessmentResult?.assessmentId}
                personalityGroup={personalityGroup}
                gender={gender}
              />

              {!isTestTaken && !personalityName && !personalityType && (
                <div>
                  <div className="flex justify-center items-center">
                    <img
                      src={noTestImage()}
                      alt=""
                      height={260}
                      width={260}
                      className="sm:block min-w-max w-40 h-40 md:w-[260px] md:h-[260px] lg:block align-top flex-shrink-0 flex justify-center items-center"
                    />
                  </div>
                  <div className="pb-2 pt-0 lg:px-[20px] lg:py-[0px] flex flex-col lg:order-2 order-1 m-4 min-h-max max-w-full mt-0 lg:mt-10">
                    {" "}
                    <h2 className="text-[#444C5E] font-medium text-[16px] lg:text-[20px]">
                      {t("plan.join_today")}
                    </h2>
                  </div>
                </div>
              )}
            </div>
            {/* -----------------------------------Continue Button &  Plain Accordian--------------------------- */}
            <div className="pb-2 pt-0 lg:px-[20px] lg:py-[0px] flex flex-col lg:order-2 order-1 m-4 min-h-max max-w-full mt-0 lg:mt-10">
              <div className="mt-[10px]">
                <AccordionContainer
                  accordions={accordianData || []}
                  defaultActiveAccordionId={accordianData?.[1]?.id}
                  personalityName={personalityName}
                  personalityType={personalityType}
                  onAccordionClick={onAccordionClick}
                  skuId={selectedPlan?.id}
                  personalityGroup={personalityGroup}
                  assessmentAttemptId={assessmentAttemptId}
                  handleContinue={handleContinue}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* -----------------------------------Second Section--------------------------- */}

      <div className="mb-12  lg:mb-12 lg:mt-0">
        <section className="pt-[20px] lg:pt-[20px] pb-[80px] bg-gradient-to-t from-[#DBFFE2] via-[#CBFFD5] to-transparent">
          <div className="container mx-auto text-center">
            <h2 className="font-semibold text-[20px] md:text-[24px] lg:text-[32px]">
              <span className="text-[#444C5E]">{t("plan.extra_perks")}</span>
              &nbsp;
              <span className="text-[#805AED]">
                {" "}
                {t("plan.personality_insight")}
              </span>
            </h2>

            <h2 className="font-normal text-[16px] md:text-[20px] lg:text-[24px] text-[#444C5E] mt-2">
              {t("plan.explore_unique_bonuses")}
            </h2>

            <div className="mt-8 flex justify-around lg:flex-row flex-col">
              <FeatureCard
                imageSrc={GrowthTips}
                imageAlt={`Share with ${selectedPlan.maxSubUserCount} friends`}
                // title={`Share with ${selectedPlan.maxSubUserCount} Friends`}
                title={`${t("plan.share_with")} ${
                  selectedPlan.maxSubUserCount
                } ${t("plan.friend_title")}`}
                description={`${t("plan.easily_share_result")} ${
                  selectedPlan.maxSubUserCount
                } ${t("plan.share_10_friend_content")}`}
              />

              <FeatureCard
                imageSrc={IdealJob}
                imageAlt="Sell Ideal Job"
                title={`${t("plan.ideal_job_title")}`}
                description={`${t("plan.ideal_job_content")}`}
              />

              <FeatureCard
                imageSrc={GrowthTips}
                imageAlt="Sell Growth Tips"
                title={`${t("plan.growth_tips_title")}`}
                description={`${t("plan.growth_tips_content")}`}
              />
            </div>
          </div>
        </section>
      </div>

      {/* -----------------------------------Third Section--------------------------- */}
      {/* <div className="container mx-auto text-center my-9">
        <h2 className="font-bold text-[35px]">
          <span className="text-[#444C5E]">Real Stories from Our</span>
          &nbsp;
          <span className="text-[#805AED]">Happy Users</span>
        </h2>
        <h2 className="font-bold text-[26px] text-[#444C5E] mt-[10px]">
          See what our users are saying about their journey of self-discovery
        </h2>
        <div className="mt-16 lg:block hidden">
          <Crousel reviews={reviews} />
        </div>
      </div> */}

      <Footer
        className="fixed"
        buttonTitle={`${t("plan.continue_cta")}`}
        onClick={handleContinue}
        buttonIcon={Arrow}
      />
    </div>
  );
};

// export const reviews = [
//   {
//     image: EmailyImage,
//     name: "Emily S.",
//     text: "This personality test gave me incredible insights and boosted my confidence!",
//   },
//   {
//     image: MichaelImage,
//     name: "Michael R.",
//     text: "Finding my ideal job was so much easier with this detailed report!",
//   },
//   {
//     image: SarahImage,
//     name: "Sarah L.",
//     text: "The customized growth tips have been a game-changer for my personal development",
//   },
//   {
//     image: MichaelImage,
//     name: "Michael 2",
//     text: "Im Michael 2 and I love this as well!",
//   },
// ];

export default Plan;
